import { loadingBarReducer as loadingBar } from 'react-redux-loading-bar';

import authentication from './authentication';
import applicationProfile from './application-profile';

import administration from 'app/modules/administration/administration.reducer';
import userManagement from 'app/modules/administration/user-management/user-management.reducer';
import register from 'app/modules/account/register/register.reducer';
import activate from 'app/modules/account/activate/activate.reducer';
import password from 'app/modules/account/password/password.reducer';
import settings from 'app/modules/account/settings/settings.reducer';
import passwordReset from 'app/modules/account/password-reset/password-reset.reducer';
// prettier-ignore
import aidasOrganisation from 'app/entities/ainnotateservice/aidas-organisation/aidas-organisation.reducer';
// prettier-ignore
import aidasCustomer from 'app/entities/ainnotateservice/aidas-customer/aidas-customer.reducer';
// prettier-ignore
import aidasProject from 'app/entities/ainnotateservice/aidas-project/aidas-project.reducer';
// prettier-ignore
import aidasObject from 'app/entities/ainnotateservice/aidas-object/aidas-object.reducer';
// prettier-ignore
import aidasVendor from 'app/entities/ainnotateservice/aidas-vendor/aidas-vendor.reducer';
// prettier-ignore
import aidasUser from 'app/entities/ainnotateservice/aidas-user/aidas-user.reducer';
// prettier-ignore
import aidasUpload from 'app/entities/ainnotateservice/aidas-upload/aidas-upload.reducer';
// prettier-ignore
import aidasProperties from 'app/entities/ainnotateservice/aidas-properties/aidas-properties.reducer';
// prettier-ignore
import aidasProjectProperty from 'app/entities/ainnotateservice/aidas-project-property/aidas-project-property.reducer';
// prettier-ignore
import aidasObjectProperty from 'app/entities/ainnotateservice/aidas-object-property/aidas-object-property.reducer';
// prettier-ignore
import aidasUploadMetaData from 'app/entities/ainnotateservice/aidas-upload-meta-data/aidas-upload-meta-data.reducer';
import aidasAuthority from 'app/entities/ainnotateservice/aidas-authority/aidas-authority.reducer';
import aidasUserAidasObjectMapping from 'app/entities/ainnotateservice/aidas-user-aidas-object-mapping/aidas-user-aidas-object-mapping.reducer';

/* jhipster-needle-add-reducer-import - JHipster will add reducer here */

const rootReducer = {
  authentication,
  applicationProfile,
  administration,
  userManagement,
  register,
  activate,
  passwordReset,
  password,
  settings,
  aidasOrganisation,
  aidasCustomer,
  aidasProject,
  aidasObject,
  aidasVendor,
  aidasUser,
  aidasUpload,
  aidasProperties,
  aidasProjectProperty,
  aidasObjectProperty,
  aidasUploadMetaData,
  aidasAuthority,
  aidasUserAidasObjectMapping,
  /* jhipster-needle-add-reducer-combine - JHipster will add reducer here */
  loadingBar,
};

export default rootReducer;
